export default __webpack_public_path__ + "static/media/September2014.d0514981.png";